/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { GetPaymentLocationResponseType } from "api/response";
import { getPaymentLocationFormDetails } from "api/services/common";
import { GetPaymentLocationRequestParams } from "api/request";
import { BaseParamsRequest } from "api/request/basParams.request";
import { locationQueryKeys } from "./locationQueryKeys";

type UseGetPaymentLocationFormDetailsParams = {
  location: string;
  config?: BaseParamsRequest<GetPaymentLocationRequestParams>;
  isQuote?: boolean;
  options?: UseQueryOptions<GetPaymentLocationResponseType>;
};

export function useGetPaymentLocationFormDetails({
  location,
  config,
  isQuote,
  options,
}: UseGetPaymentLocationFormDetailsParams) {
  return useQuery({
    queryKey: locationQueryKeys.paymentLocationFormDetailsConfig(location, { ...config, isQuote }),
    queryFn: () => getPaymentLocationFormDetails(location, config, isQuote).then((res) => res.data),
    ...options,
  });
}
